import { init, RematchDispatch, RematchRootState } from "@rematch/core"
import selectPlugin from "@rematch/select"

import { models, RootModel } from "./models"

const store = init({
  models,
  plugins: [selectPlugin()],
})

export type Dispatch = RematchDispatch<RootModel>
export type RootState = RematchRootState<RootModel>
export type Store = typeof store

export default store
